<script setup lang="ts">
import { computed } from "vue"
import { ExternalLink, RefreshCw, Rocket } from "lucide-vue-next"
import { Button } from "@/components/ui/button"
import { Badge } from "@/components/ui/badge"

const props = defineProps<{
  version: string
  installing?: boolean
  /**
   * Non-empty on macOS, where updates come from the Mac App Store and the app is not allowed to
   * install them itself (App Review Guideline 2.5.2) — see `useUpdater.ts`. It switches this toast
   * from "downloaded, ready to restart" to "available in the store", because promising a one-click
   * install we can't perform is the one thing this notification must not do.
   */
  storeUrl?: string
  onInstall: () => void
  onDismiss: () => void
}>()

const isStoreUpdate = computed(() => Boolean(props.storeUrl))
</script>

<template>
  <div class="relative w-95 max-w-[calc(100vw-2rem)] overflow-hidden bg-background shadow-lg shadow-black/5">
    <div class="pointer-events-none absolute inset-0 bg-linear-to-tl from-primary/5 via-transparent to-transparent" />
    <div class="pointer-events-none absolute inset-0 bg-linear-to-br from-violet-500 via-transparent to-transparent" />
<!--    <div class="pointer-events-none absolute inset-0 bg-linear-to-bl from-violet-400 via-transparent to-transparent" />-->
<!--    <div class="pointer-events-none absolute inset-0 bg-linear-to-tr from-violet-400 via-transparent via-30% to-transparent" />-->

    <div class="relative flex gap-3 p-4">
<!--      <div class="flex size-10 shrink-0 items-center justify-center rounded-full bg-primary/10 text-primary">-->
<!--        <Rocket class="size-5" />-->
<!--      </div>-->

      <div class="min-w-0 flex-1">
        <div class="flex items-center gap-2">
          <p class="font-medium leading-none">
            Доступно обновление
          </p>
          <Badge variant="secondary" class="font-mono text-[11px]">
            v{{ props.version }}
          </Badge>
        </div>
        <p class="mt-1.5 text-sm text-muted-foreground">
          {{
            isStoreUpdate
              ? 'Новая версия уже в App Store — откройте страницу приложения и нажмите «Обновить»'
              : 'Обновление уже скачано и готово к установке, мы лишь перезапустим приложение'
          }}
        </p>

        <div class="mt-3 flex gap-2">
          <Button v-if="isStoreUpdate" size="sm" @click="props.onInstall">
            <ExternalLink class="size-3.5" />
            Открыть App Store
          </Button>
          <Button v-else size="sm" :loading="props.installing" @click="props.onInstall">
            <RefreshCw v-if="!props.installing" class="size-3.5" />
            Установить
          </Button>
          <Button size="sm" variant="ghost" :disabled="props.installing" @click="props.onDismiss">
            Позже
          </Button>
        </div>
      </div>
    </div>
  </div>
</template>
